import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { CaretLeftIcon } from "../../Icons";

function getColor(color) {
  switch (color) {
    case "main":
      return "em-c-pagination__link--main";
    case "accent":
      return "em-c-pagination__link--accent";
    case "blue":
    default:
      return "";
  }
}

/** PaginationFirst is a button to navigate to the first page */
const PaginationFirst = props => {
  const { disabled, color, onChange, className, children, ...other } = props;

  return (
    <li
      className={clsx(
        "em-c-pagination__item",
        { "em-u-clickable": !disabled },
        className
      )}
      onClick={!disabled ? onChange : () => {}}
      {...other}
    >
      <div
        className={clsx("em-c-pagination__link", getColor(color), {
          "em-is-disabled": disabled
        })}
      >
        <CaretLeftIcon
          className="em-c-pagination__icon em-pagination-icon"
          size="small"
        />
      </div>
    </li>
  );
};

PaginationFirst.propTypes = {
  /** If the item is disabled */
  disabled: PropTypes.bool,
  /** URL of the page */
  href: PropTypes.string,
  /** function emitted on change, returns this pages inner value */
  onChange: PropTypes.func,
  /** Additional css classes to append to the outer element */
  className: PropTypes.string,
  /** Theme color of the buttons */
  color: PropTypes.oneOf(["blue", "main", "accent"])
};

PaginationFirst.defaultProps = {
  disabled: false,
  onChange: () => {},
  className: "",
  href: "",
  color: "blue"
};

export default PaginationFirst;
